import {NgModule} from '@angular/core';
import {RefreshTextComponent} from './refresh-text/refresh-text.component';
import {ChipTextComponent} from './chip-text/chip-text.component';
import {StatusTextComponent} from './status-text/status-text.component';
import {CapitalizeTextComponent} from './capitalize-text/capitalize-text.component';
import {IconsModule} from '../icons/icons.module';

@NgModule({
    declarations: [
        RefreshTextComponent,
        ChipTextComponent,
        StatusTextComponent,
        CapitalizeTextComponent
    ],
    imports: [
        IconsModule
    ],
    exports: [
        RefreshTextComponent,
        ChipTextComponent,
        StatusTextComponent,
        CapitalizeTextComponent
    ]
})
export class TextModule {
}
